/* FIX OEE Report Harian Table - Staging Only
   Masalah: header tabel Report Harian OEE menumpuk/nowrap.
   Solusi: runtime detect tabel report harian lalu paksa modal lebar, table scroll horizontal,
   header wrap, dan judul header panjang dibuat multi-line.
*/

(function () {
  const STYLE_ID = "oee-report-harian-runtime-fix-style";

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .oee-report-harian-modal-fix {
        width: 98vw !important;
        max-width: 98vw !important;
      }

      .oee-report-harian-content-fix {
        width: 98vw !important;
        max-width: 98vw !important;
        overflow: hidden !important;
      }

      .oee-report-harian-wrap-fix {
        overflow-x: auto !important;
        overflow-y: auto !important;
        max-width: 100% !important;
        max-height: calc(100vh - 145px) !important;
        padding-bottom: 12px !important;
      }

      table.oee-report-harian-table-fix {
        width: max-content !important;
        min-width: 2600px !important;
        table-layout: auto !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
      }

      table.oee-report-harian-table-fix th,
      table.oee-report-harian-table-fix td {
        box-sizing: border-box !important;
        border: 1px solid #d6dee8 !important;
        vertical-align: middle !important;
      }

      table.oee-report-harian-table-fix th,
      table.oee-report-harian-table-fix th * {
        white-space: normal !important;
        word-break: normal !important;
        overflow-wrap: anywhere !important;
        text-overflow: clip !important;
        overflow: visible !important;
        line-height: 1.15 !important;
        text-align: center !important;
        font-size: 10.5px !important;
        font-weight: 800 !important;
      }

      table.oee-report-harian-table-fix th {
        min-width: 120px !important;
        max-width: 230px !important;
        height: auto !important;
        padding: 8px 9px !important;
        background: #f8fafc !important;
        color: #111827 !important;
        position: sticky !important;
        top: 0 !important;
        z-index: 20 !important;
      }

      table.oee-report-harian-table-fix th.oee-report-wide-header {
        min-width: 175px !important;
        max-width: 280px !important;
      }

      table.oee-report-harian-table-fix th.oee-report-small-header {
        min-width: 90px !important;
        max-width: 115px !important;
      }

      table.oee-report-harian-table-fix td {
        min-width: 82px !important;
        white-space: nowrap !important;
        text-align: center !important;
        padding: 7px 10px !important;
        font-size: 12px !important;
        line-height: 1.2 !important;
        background: #ffffff !important;
      }

      table.oee-report-harian-table-fix td:nth-child(6),
      table.oee-report-harian-table-fix td:nth-child(7),
      table.oee-report-harian-table-fix td:nth-child(8) {
        font-weight: 800 !important;
      }

      .oee-report-harian-wrap-fix::-webkit-scrollbar {
        height: 12px;
        width: 12px;
      }

      .oee-report-harian-wrap-fix::-webkit-scrollbar-thumb {
        background: #64748b;
        border-radius: 10px;
      }

      .oee-report-harian-wrap-fix::-webkit-scrollbar-track {
        background: #e2e8f0;
      }
    `;

    document.head.appendChild(style);
  }

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function formatHeaderText(text) {
    let raw = String(text || "")
      .replace(/&lt;br\s*\/?&gt;/gi, " ")
      .replace(/<br\s*\/?>/gi, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (!raw) return "";

    const jam = raw.match(/^JAM\s*(\d+)$/i);
    if (jam) return "JAM<br>" + escapeHtml(jam[1]);

    if (/^RPH$/i.test(raw)) return "RPH";
    if (/^TOTAL PRODUKSI$/i.test(raw)) return "TOTAL<br>PRODUKSI";
    if (/^TOTAL NG$/i.test(raw)) return "TOTAL<br>NG";
    if (/^TOTAL INSECT$/i.test(raw)) return "TOTAL<br>INSECT";

    let t = raw;

    t = t.replace(/\s*-\s*/g, " -|");
    t = t.replace(/\s*\(([^)]+)\)/g, "|($1)");
    t = t.replace(/\s+OVER\s+/gi, " OVER|");
    t = t.replace(/\s+MINUS\s+/gi, " MINUS|");
    t = t.replace(/\s+VISUAL\s+/gi, " VISUAL|");
    t = t.replace(/\s+UKURAN\s+/gi, " UKURAN|");
    t = t.replace(/\s+CACAT\s+/gi, " CACAT|");
    t = t.replace(/\s+TOUCHED\s+/gi, " TOUCHED|");
    t = t.replace(/\s+UNTOUCHED\s+/gi, " UNTOUCHED|");
    t = t.replace(/\s+REJECT\s+/gi, " REJECT|");

    const parts = t
      .split("|")
      .map((x) => x.trim())
      .filter(Boolean);

    if (parts.length <= 1) {
      const words = raw.split(" ");
      if (words.length > 2) {
        const mid = Math.ceil(words.length / 2);
        return escapeHtml(words.slice(0, mid).join(" ")) + "<br>" + escapeHtml(words.slice(mid).join(" "));
      }
      return escapeHtml(raw);
    }

    return parts.map(escapeHtml).join("<br>");
  }

  function looksLikeReportHarianTable(table) {
    const txt = (table.innerText || table.textContent || "").toUpperCase();
    return (
      txt.includes("TOTAL PRODUKSI") &&
      txt.includes("TOTAL NG") &&
      (txt.includes("NG -") || txt.includes("KARAT") || txt.includes("UKURAN"))
    );
  }

  function findModalLikeParent(el) {
    let p = el.parentElement;
    let count = 0;

    while (p && count < 12) {
      const cls = String(p.className || "").toLowerCase();
      const role = String(p.getAttribute && p.getAttribute("role") || "").toLowerCase();
      const pos = window.getComputedStyle(p).position;

      if (
        cls.includes("modal-dialog") ||
        cls.includes("modal-content") ||
        cls.includes("modal") ||
        role === "dialog" ||
        pos === "fixed"
      ) {
        return p;
      }

      p = p.parentElement;
      count += 1;
    }

    return null;
  }

  function applyFixToTable(table) {
    if (!table || table.dataset.oeeReportHarianFixed === "1") return;
    if (!looksLikeReportHarianTable(table)) return;

    table.dataset.oeeReportHarianFixed = "1";
    table.classList.add("oee-report-harian-table-fix");

    const ths = Array.from(table.querySelectorAll("th"));
    const colCount = Math.max(ths.length, table.rows && table.rows[0] ? table.rows[0].cells.length : 0);

    table.style.minWidth = Math.max(2600, colCount * 145) + "px";
    table.style.width = "max-content";
    table.style.tableLayout = "auto";

    ths.forEach((th) => {
      const raw = String(th.textContent || "").replace(/\s+/g, " ").trim();

      th.setAttribute("title", raw);
      th.style.whiteSpace = "normal";
      th.style.wordBreak = "normal";
      th.style.overflowWrap = "anywhere";
      th.style.lineHeight = "1.15";
      th.style.textAlign = "center";

      if (/^JAM\s+\d+/i.test(raw)) {
        th.classList.add("oee-report-small-header");
      }

      if (
        raw.length > 14 ||
        raw.toUpperCase().includes("NG") ||
        raw.toUpperCase().includes("UKURAN") ||
        raw.toUpperCase().includes("CACAT") ||
        raw.toUpperCase().includes("TOUCHED") ||
        raw.toUpperCase().includes("REJECT")
      ) {
        th.classList.add("oee-report-wide-header");
      }

      if (true) {
        th.innerHTML = formatHeaderText(raw);
        th.dataset.oeeHeaderTextFixed = "1";
      }
    });

    let wrap = table.parentElement;
    if (wrap) {
      wrap.classList.add("oee-report-harian-wrap-fix");
      wrap.style.overflowX = "auto";
      wrap.style.overflowY = "auto";
      wrap.style.maxWidth = "100%";
    }

    let p = table.parentElement;
    for (let i = 0; p && i < 4; i += 1) {
      p.classList.add("oee-report-harian-wrap-fix");
      p.style.overflowX = "auto";
      p.style.maxWidth = "100%";
      p = p.parentElement;
    }

    const modalParent = findModalLikeParent(table);
    if (modalParent) {
      modalParent.classList.add("oee-report-harian-modal-fix");
      modalParent.style.width = "98vw";
      modalParent.style.maxWidth = "98vw";
    }

    const contentParent = modalParent && modalParent.querySelector
      ? modalParent.querySelector(".modal-content")
      : null;

    if (contentParent) {
      contentParent.classList.add("oee-report-harian-content-fix");
    }

    console.log("[OEE Report Harian Fix] table fixed:", { columns: colCount });
  }

  function scan() {
    injectStyle();

    const tables = Array.from(document.querySelectorAll("table"));
    tables.forEach(applyFixToTable);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(scan);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.__OEE_REPORT_HARIAN_FIX_SCAN__ = scan;
  setInterval(scan, 1000);
})();
